<div class="map-drawer">
    <working-list *ngIf="data"
                  [mapEvent]="mapEvent"
                  [data]="data"
                  (onFilter)="filter($event)"
                  (onItemSelected)="selectItem($event)"></working-list>
</div>